import { render, staticRenderFns } from "./VDesignChatForm.vue?vue&type=template&id=1fe83617&"
import script from "./VDesignChatForm.vue?vue&type=script&lang=ts&"
export * from "./VDesignChatForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports